import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject, Subscription, filter, takeUntil } from 'rxjs';
import { BasketService } from 'src/app/services/basket.service';
import { DataService } from 'src/app/services/data.service';
import { Drink } from 'src/interfaces/drink.model';
import { Food } from 'src/interfaces/food.model';
import { Locale } from 'src/interfaces/locale.model';
import { SheetDirective } from 'src/app/directives/sheet.directive';

@Component({
    selector: 'app-menu-basket-dialog',
    templateUrl: './menu-basket-dialog.component.html',
    styleUrls: ['./menu-basket-dialog.component.css'],
    standalone: false
})
export class MenuBasketDialogComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(
    private dialogRef: MatDialogRef<MenuBasketDialogComponent>,
    private dataService: DataService,
    private basketService: BasketService
  ) {
    this.locale = this.dataService.locale;

    // Затемнение и Esc закрывают окно с анимацией, а не мгновенно
    this.dialogRef.disableClose = true;
    this.dialogRef.backdropClick().subscribe(() => this.close());
    this.dialogRef.keydownEvents()
      .pipe(filter((event) => event.key === 'Escape'))
      .subscribe(() => this.close());
  }

  @ViewChild('scrollContent') scrollContent!: ElementRef;
  @ViewChild(SheetDirective) sheet!: SheetDirective;

  locale: Locale | null;
  foods: Food[] | null = null;
  drinks: Drink[] | null = null;

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.basketService.foods
    .pipe(takeUntil(this.destroy$))
    .subscribe((data: Food[]) => {
      this.foods = data;
      console.log('MenuBasketDialog | ngOnInit() | foods:', this.foods.length ? this.foods.map(x => x.title).join(', ') : 'empty');
      if (this.drinks && this.drinks.length == 0 && this.foods.length == 0) {
        this.close();
      }
    });

    this.basketService.drinks
    .pipe(takeUntil(this.destroy$))
    .subscribe((data: Drink[]) => {
      this.drinks = data;
      console.log('MenuBasketDialog | ngOnInit() | drinks:', this.drinks.length ? this.drinks.map(x => x.title).join(', ') : 'empty');
      if (this.drinks.length == 0 && this.foods && this.foods.length == 0) {
        this.close();
      }
    });
  }

  ngAfterViewInit() {
    this.scrollContent.nativeElement.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll(event: any) {
    const scrollOffset = this.scrollContent.nativeElement.scrollTop;
  }

  // Отписка от событий при уничтожении компонента
  ngOnDestroy() {
    this.scrollContent.nativeElement.removeEventListener('scroll', this.onScroll.bind(this));
    this.destroy$.next();
    this.destroy$.complete();
  }

  /** Окно уезжает вниз, затем диалог закрывается (onSheetClosed). Корзина
   *  пуста уже при открытии (окна ещё нет) — закрывается сразу */
  close(): void {
    console.log('MenuBasketDialog | close()');
    if (this.sheet) {
      this.sheet.dismiss();
    } else {
      this.dialogRef.close();
    }
  }

  onSheetClosed(): void {
    this.dialogRef.close();
  }
}
